import store from './../../../store';

import {
  FETCH_ALL_ORDER_PRODUCTS,
  RESET_ORDER_PRODUCTS,
  REMOVE_ORDER_PRODUCT,
  ADD_ORDER_PRODUCT,
  UPDATE_ORDER_PRODUCT,
} from './../../mutation-types';

export default {
  [RESET_ORDER_PRODUCTS](state) {
    state.all = [];
  },

  [FETCH_ALL_ORDER_PRODUCTS](state, orderProducts) {
    state.all = orderProducts;
  },

  [REMOVE_ORDER_PRODUCT](state, id) {
    state.all = state.all.filter(p => p.id !== id);
  },

  [ADD_ORDER_PRODUCT](state, orderProduct) {
    store.state.tax.all.map((t) => {
      if (t.id === orderProduct.taxId) {
        orderProduct.taxPercentage = t.taxPercentage;
      }
      return t;
    });
    state.all.push(orderProduct);
  },

  [UPDATE_ORDER_PRODUCT](state, { orderProduct, id }) {
    store.state.tax.all.forEach((t) => {
      if (t.id.toString() === orderProduct.taxId.toString()) {
        orderProduct.taxPercentage = t.taxPercentage;
      }
    });
    state.all = state.all.map((p) => {
      if (p.id.toString() === id.toString()) {
        return Object.assign({}, p, orderProduct);
      }

      return p;
    });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/orderProduct/mutations.js